<nb-actions [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-action (click)="like()">
    <nb-icon
      *ngIf="!liked.value"
      [icon]="liked.value ? 'liked' : 'like'"
      pack="liked-icon"
      status="info"
    ></nb-icon>

    <i *ngIf="liked.value" class="fas fa-thumbs-up" style="color: #0095ff"></i>

    <span *ngIf="noLiked > 0">
      {{ noLiked | number }}
    </span>
    <span *ngIf="noLiked == 0"> Thích </span>
  </nb-action>
</nb-actions>
